import Fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDatasetMarkdown: ({ category, code }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_DATASET_MARKDOWN,
    readStatus,
    { category, code },
    fetchConfig([category, code, readStatus]),
  ),
};
